import React, { Component } from 'react';

import 'react-dates/initialize'; // Needs to be imported before date picker components
import { SingleDatePicker } from 'react-dates';
import { getClass } from '../../../utils/component-helpers';

import 'react-dates/lib/css/_datepicker.css';
import './single-date-picker.scss';

class SingleDayPicker extends Component {
	constructor(props) {
		super(props);

		this.state = {
			date: this.props.date,
		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.date !== this.props.date) {
			this.setState({date: this.props.date});
		}
	}

	setDate(date) {
		this.setState({date: date});
		this.props.setDate(date);
	}

	render() {
		return (
			<div className={getClass('single-day-picker', {
				'error': this.props.error,
			})}>
				<SingleDatePicker
					id={this.props.id}
					date={this.state.date}
					onDateChange={(date) => this.setDate(date)}
					focused={this.state.focused}
					onFocusChange={({ focused }) => this.setState({ focused })}
					// Calendar options
					displayFormat="MM/DD/YY"
					numberOfMonths={1}
					hideKeyboardShortcutsPanel={true}
					transitionDuration={0}
					placeholder={this.props.placeholder || 'Date'}
				/>
			</div>
		);
	}
}

export default SingleDayPicker;
